import { Grid, styled } from "@mui/material";
import {
  AppliedItem,
  InputBox,
  MainTitle,
  RaffleContent,
} from "../../../styles/theme";
import { X } from "@phosphor-icons/react";
import { NoticeData } from "../../../system/types/Notice";
import { createRef, useEffect, useState } from "react";
import { InitNoticeDetailData } from "../../../system/types/initObject";
import AlertModal from "../../Common/AlertModal";
import {
  ChangeEventArgs,
  CheckBoxComponent,
} from "@syncfusion/ej2-react-buttons";
import CrossEditor from "../../Common/Editor/CrossEditor";
import dayjs from "dayjs";
import { NoticeApi } from "../../../system/api/NoticeApi";
import { ErrorHandler } from "../../../system/ApiService";
import { ModalState, ModalStateType } from "../../../system/Constants";
import { CustomButtonGray, CustomButtonGreen } from "../../../styles/button";
import { CustomText } from "../../../styles/CustomText";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";

function validation(data: NoticeData, mainCheck: boolean) {
  if (!data.title) {
    AlertModal("check", "제목을 작성해주세요.");
    return false;
  } else if (
    mainCheck &&
    (data.mainStartDate === null || data.mainEndDate === null)
  ) {
    AlertModal(
      "check",
      "주요 공지 설정 시, <br> 시작 기간과 종료 기간을 모두 입력해주세요."
    );
    return false;
  } else if (
    mainCheck &&
    data.mainStartDate &&
    data.mainEndDate &&
    new Date(data.mainStartDate) > new Date(data.mainEndDate)
  ) {
    AlertModal(
      "check",
      "주요 공지 설정 시,<br>시작 기간은 종료 기간보다 뒤로 설정할 수 없습니다.<br>올바른 기간을 선택해주세요."
    );
    return false;
  }
  return true;
}

interface AccommodationNoticeEditProps {
  handleClose: () => void;
  selectedNotice: NoticeData;
  setNoticeState: React.Dispatch<React.SetStateAction<ModalStateType>>;
  getNoticeData: () => void;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
}

function AccommodationNoticeEdit({
  handleClose,
  selectedNotice,
  setNoticeState,
  getNoticeData,
  setPageNumber,
}: AccommodationNoticeEditProps) {
  const [formData, setFormData] = useState<NoticeData>(InitNoticeDetailData);
  const ref = createRef<CrossEditor>();
  const [mainCheck, setMainCheck] = useState(false);
  const [infoUpdate, setInfoUpdate] = useState(false);
  const [started, setStarted] = useState<boolean>(false);
  const onLoaded = (_: any, editor: { GetBodyValue: () => any }) => {
    setStarted(true);
  };

  const onChangeDateTimePicker = (args: any) => {
    if (args.value) {
      setFormData({
        ...formData,
        mainStartDate: dayjs(args.value[0])
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        mainEndDate: dayjs(args.value[1])
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
      });
    } else {
      setFormData({
        ...formData,
        mainStartDate: null,
        mainEndDate: null,
      });
    }
  };
  function onChange(args: any) {
    setFormData({
      ...formData,
      [(args.target as HTMLInputElement).name]: args.target.value,
    });
  }

  const onChangeCheckBox = (args: ChangeEventArgs): void => {
    if (mainCheck) {
      setFormData({
        ...formData,
        mainStartDate: null,
        mainEndDate: null,
      });
    }
    setMainCheck(!mainCheck);
  };
  const params = {
    Width: "100%",
    Height: 400,
  };

  var submitcheck = false;
  function onSave() {
    if (!started) {
      window.alert(
        "에디터가 로드되지 않았습니다. 잠시 후 다시 시도해 주시기 바랍니다."
      );
      return;
    }

    if (
      submitcheck === false &&
      ref.current &&
      validation(formData, mainCheck)
    ) {
      const editor = ref.current.editorRef;
      submitcheck = true;
      if (formData.id) {
        NoticeApi.updateNotice({
          ...formData,
          type: "휴양소",
          content: editor.GetBodyValue() || "",
        })
          .then(() => {
            AlertModal("success", "공지사항이 수정되었습니다.");
            setNoticeState(ModalState.table);
            getNoticeData();
          })
          .catch((err) => {
            let msg = ErrorHandler(err);
            AlertModal("msg", msg);
          })
          .finally(() => {
            submitcheck = false;
          });
      } else {
        NoticeApi.createNotice({
          ...formData,
          type: "휴양소",
          content: editor.GetBodyValue() || "",
        })
          .then(() => {
            AlertModal("success", "공지사항이 작성되었습니다.");
            setNoticeState(ModalState.table);
            getNoticeData();
          })
          .catch((err) => {
            let msg = ErrorHandler(err);
            AlertModal("msg", msg);
          })
          .finally(() => {
            submitcheck = false;
          });
      }
    }
  }
  useEffect(() => {
    if (selectedNotice.id) {
      setFormData(selectedNotice);
      if (selectedNotice.mainStartDate) {
        setMainCheck(true);
      }
    }
    setInfoUpdate(true);
  }, [selectedNotice, setMainCheck]);

  return (
    <Grid container item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RaffleContent>
            <MainTitle>
              휴양소 공지사항 {selectedNotice?.id ? "수정" : "작성"}{" "}
            </MainTitle>
            <AppliedItem onClick={handleClose}>
              <X size={32} />
            </AppliedItem>
          </RaffleContent>
        </Grid>
      </Grid>
      <StyledNoticeBox container mt="20px">
        <StyledNoticeTable container alignItems="center">
          <Grid item sx={{ width: "120px" }}>
            <CustomText type="subtitle">제목</CustomText>
          </Grid>
          <Grid item sx={{ width: "calc(100% - 120px)" }}>
            <InputBox
              type="text"
              name="title"
              onChange={onChange}
              value={formData.title || ""}
              placeholder="제목을 입력해주세요."
            />
          </Grid>
        </StyledNoticeTable>
        <StyledNoticeTable container alignItems="center">
          <Grid container item xs={12} sm={6}>
            <CustomText type="subtitle" width="120px">
              주요 공지
            </CustomText>
            <Grid>
              <CheckBoxComponent
                name="check"
                onChange={onChangeCheckBox}
                checked={mainCheck}
              />
            </Grid>
          </Grid>
          {mainCheck && (
            <Grid container item alignItems="center" xs={12} sm={6}>
              <CustomText type="subtitle" width="120px">
                주요 공지 기간
              </CustomText>
              <Grid
                container
                item
                alignItems="center"
                sx={{ width: "calc(100% - 120px)" }}
              >
                <DateRangePickerComponent
                  placeholder="주요 공지 기간을 선택해주세요."
                  locale="ko"
                  format="yyyy-MM-dd"
                  value={
                    formData.mainStartDate && formData.mainEndDate
                      ? [
                          new Date(formData.mainStartDate),
                          new Date(formData.mainEndDate),
                        ]
                      : undefined
                  }
                  showClearButton={false}
                  delayUpdate={true}
                  onChange={(args: any) => {
                    onChangeDateTimePicker(args);
                  }}
                />
              </Grid>
            </Grid>
          )}
        </StyledNoticeTable>
        <StyledNoticeTable container>
          <CustomText type="subtitle" width="120px">
            내용
          </CustomText>
          <StyledTextBox item sx={{ width: "calc(100% - 120px)" }}>
            {infoUpdate && (
              <CrossEditor
                ref={ref}
                name="VehicleNotice"
                params={params}
                value={formData.content}
                onLoaded={onLoaded}
              />
            )}
          </StyledTextBox>
        </StyledNoticeTable>
        <Grid container justifyContent="center" mt="10px">
          <CustomButtonGreen onClick={onSave}>저장</CustomButtonGreen>
          <CustomButtonGray
            onClick={() => {
              setNoticeState(ModalState.table);
              setPageNumber(0);
            }}
          >
            목록으로
          </CustomButtonGray>
        </Grid>
      </StyledNoticeBox>
    </Grid>
  );
}

export default AccommodationNoticeEdit;

const StyledNoticeBox = styled(Grid)({
  borderTop: "1px solid #DCDFE3",
});

const StyledNoticeTable = styled(Grid)({
  borderBottom: "1px solid #DCDFE3",
  padding: "10px 5px",
  minHeight: "60px",
});

const StyledTextBox = styled(Grid)({
  minHeight: "300px",
});
